import { useQuery } from '@apollo/client';
import { FETCH_COURSE } from 'graphql/queries';
// for deprication
export const useFetchCourse = (variables) => {
  return useQuery(FETCH_COURSE, { variables });
}